import React from "react";
import CalendarRow from "./CalendarRow";

class CalendarView extends React.Component {
  transformListings = (listings) => {
    return listings.map((listing) => {
      const calendarMap = {};
      listing?.calendarData?.blockedDates.forEach((item) => {
        const date = item.blockedDates;
        if (!calendarMap[date]) calendarMap[date] = [];
        calendarMap[date].push(item);
      });
      return { ...listing, calendarMap };
    });
  };

  render() {
    const { listings, viewMode, canScrollLeft, dates } = this.props;
    const transformedListings = this.transformListings(listings);
    return (
      <>
        {transformedListings.map((listing) => (
          <CalendarRow
            key={listing.id + listing.title}
            listing={listing}
            dates={dates}
            canScrollLeft={canScrollLeft}
          />
        ))}
      </>
    );
  }
}

export default CalendarView;
